import React, { useEffect, useState } from "react";
import ItemsList from "./items-list/items-list";
import ItemsAdd from "./items-add/items-add";
import ItemsEdit from "./items-edit/items-edit";
import ItemsDelete from "./items-delete/items-delete";
import { useNavigate } from "react-router-dom";
import { checkAuthState } from "../../authentication/auth-utils/auth-utils";

const ItemsContainer = () => {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        checkAuthState((isLoggedIn) => {
          setIsAuthorized(isLoggedIn);
        });
    }, []);

    useEffect(() => {
        if (isAuthorized === false) {
          navigate('/');
        }
    }, [isAuthorized, navigate]);
    
    return (
        <>
            <div style={{ padding: 20 }}>
                <ItemsList/>
                <ItemsAdd/>
                {/* <ItemsEdit/>
                <ItemsDelete/> */}
            </div>
        </>
    )
};

export default ItemsContainer;